import * as React from "react";
import { useHostAdapter } from "../platform";

/**
 * The running add-in's version, read from its own manifest as deployed beside the
 * bundle. Each host ships its own manifest with its own version, so this reads the
 * running host's rather than a fixed filename -- otherwise every host reports Word's.
 */
export const useAddInVersion = (): string => {
  const host = useHostAdapter();
  const [version, setVersion] = React.useState<string>("");

  React.useEffect(() => {
    fetch(`/${host.manifestFileName}`)
      .then((res) => res.text())
      .then((xml) => {
        const match = xml.match(/<Version>([^<]*)<\/Version>/);
        if (match) setVersion(match[1]);
      })
      .catch(() => {});
  }, [host]);

  return version;
};
